import React from 'react';
import * as R from 'ramda';

import { schema } from './collinsMpcConstants';
import { getAttributeDataRows } from './collinsMpcUtilities';

import './collinsMpcPdfReport.css';

interface Props {
  workOrderAsset: any;
}

const GeneralNotes = ({ workOrderAsset }: Props) => {
  const generalNotes = getAttributeDataRows(workOrderAsset?.attributes, [
    schema.inspectionData.generalNotes,
  ]);

  const value = R.pathOr('', [0, 'value'], generalNotes);

  return (
    <div styleName="section-box no-margin">
      <div styleName="section-title">General Notes</div>
      <div styleName="note-content">{value}</div>
    </div>
  );
};

export default GeneralNotes;
